
import { Enums } from '@bode-canada/core';
import GridSync from '@/ui-kit/components/grid';
import Button from '@/ui-kit/components/button';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { TooltipMessage } from '@/ui-kit/components/tooltip/enum';
import CommissionHelper from '@/utils/commission';
import { LISTING_ORIGIN_TYPES, LISTING_TRACK_EVENT_ORIGIN_TYPES, PROVINCES } from '@/constants';
import { ESTIMATED_FEES_TABLE_COLUMNS, ESTIMATED_FEES_TABLE_SIZES } from './constants';
import { EstimatedFeesTableColumnKey } from './enums';
import routes from '@/constants/routes';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import IconHintTooltip from '@/components/shared/tooltips/icon-hint-tooltip';
import { IconHintTooltipProperty } from '@/components/shared/tooltips/icon-hint-tooltip/enum';

export default {
  name: 'ListingEstimatedFees',
  components: {
    IconHintTooltip,
    GridSync,
    Typography,
    Button,
  },
  props: {
    id: {
      required: true,
      type: Number,
    },
    origin: {
      required: true,
      type: String,
    },
    province: {
      required: true,
      type: String,
    },
    price: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      StyleColorSchemeType,
      TypographyType,
      IconHintTooltipProperty,
      ESTIMATED_FEES_TABLE_COLUMNS,
      ESTIMATED_FEES_TABLE_SIZES,
      routes,
    };
  },
  computed: {
    tooltipMessage() {
      return this.province === PROVINCES.BC
        ? TooltipMessage.EstimatedFeeMessageBC
        : TooltipMessage.EstimatedFeeMessageAB;
    },
    isBodeListing() {
      return this.origin === Enums.ListingOriginEnum.BODE;
    },
    realtorFeeAmount() {
      return CommissionHelper.getBuyerCommission(this.price, this.province);
    },
    estimatedFeesDescription() {
      if (this.isBodeListing) {
        return `When you're empowered to buy your own home, you don't need an agent.
          And no agent means no commission. We charge no fee (to the buyer or
          seller) when you buy a home on Bōde, saving you both thousands.`;
      }

      return `When you are empowered by Bōde, you don't need an agent to buy or
        sell your home. For the ultimate buying experience, connect directly
        with a Bōde seller.`;
    },
    tableRows() {
      return [
        {
          [EstimatedFeesTableColumnKey.Characteristic]: { value: 'List price' },
          [EstimatedFeesTableColumnKey.MoneyAmount]: { value: this.price },
        },
        {
          [EstimatedFeesTableColumnKey.Characteristic]: { value: 'Typical buy-side realtor' },
          [EstimatedFeesTableColumnKey.MoneyAmount]: { value: this.realtorFeeAmount },
        },
        {
          [EstimatedFeesTableColumnKey.Characteristic]: { value: 'Bōde' },
          [EstimatedFeesTableColumnKey.MoneyAmount]: { value: 0 },
        },
        {
          [EstimatedFeesTableColumnKey.Characteristic]: { value: 'Saving with Bōde' },
          [EstimatedFeesTableColumnKey.MoneyAmount]: { value: this.realtorFeeAmount },
        },
      ];
    },
  },
  methods: {
    handleHowItWorksClick() {
      this.track(ListingPageEvent.LearnHowItWorksClicked);
    },
    track(event) {
      const listingTrackEventOrigin = this.origin === Enums.ListingOriginEnum.BODE
        ? LISTING_TRACK_EVENT_ORIGIN_TYPES.Bode
        : LISTING_TRACK_EVENT_ORIGIN_TYPES.MLS;

      this.$track(
        `${listingTrackEventOrigin}_${event}`,
        {
          listingId: this.id,
          listingType: LISTING_ORIGIN_TYPES[this.origin] || this.origin,
        },
      );
    },
  },
};
